import CategoriaService from '../services/categoria-service'
import ColecaoService from '../services/colecao-service'
import TagService from '../services/tag-service'
import AuthorsService from '../services/authors-service'
import EditoraService from '../services/editora-service'
import MidiaService from '../services/midia-service'
import IdiomaService from '../services/idioma-service'
import MembrosService from '../services/membros-service'
import ObraService from '../services/obra-service'

export default {
  login: ({ commit }, { user, token }) => {
    commit('user', user)
    commit('token', token)
  },
  logout: ({ commit }) => {
    commit('logout')
  },
  getCategorias: ({ commit }) => {
    CategoriaService.getAll({
      orderBy: [{ orderBy: 'nome_categoria', direction: 'asc' }],
      limit: 100,
    })
      .then(({ data }) => {
        commit('categorias', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getColecoes: ({ commit }) => {
    ColecaoService.getAll({
      orderBy: [{ orderBy: 'nome_colecao', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit('colecoes', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getTags: ({ commit }) => {
    TagService.getAll({
      orderBy: [{ orderBy: 'nome_tag', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit('tags', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAutores: ({ commit }) => {
    AuthorsService.getAll({
      orderBy: [{ orderBy: 'nome_autor', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit(
          'autores',
          data.data.map(({ id, nome_autor }) => {
            return { id, nome: nome_autor }
          })
        )
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getEditoras: ({ commit }) => {
    EditoraService.getAll({
      orderBy: [{ orderBy: 'nome_editora', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit('editoras', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getMidias: ({ commit }) => {
    MidiaService.getAll({
      orderBy: [{ orderBy: 'nome_midia', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit('midias', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getIdiomas: ({ commit }) => {
    IdiomaService.getAll({
      orderBy: [{ orderBy: 'nome_idioma', direction: 'asc' }],
      limit: 5000
    })
      .then(({ data }) => {
        commit('idiomas', data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getObras:({ commit }) => {
    commit('obras', [])
    return ObraService.list()
      .then(
        ({data}) => {
          const obras = data.map((obra) => {
            obra.name = `${obra.titulo} ${obra.subtitulo ? obra.subtitulo : ''}`
            obra.name = obra.name
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
            return obra
          })
          commit('obras', obras)
        }
      )
  },

  getMembros:({ commit }) => {
    return MembrosService.list()
      .then(({data}) => {

        const membros = data.map((membro) => {
          membro.name = membro.nome + ' ' + membro.sobrenome
          membro.name = membro.name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
          return membro
        })
        commit('membros', membros)
      }
      )
  }
}
